import { isAccessible } from 'app/components/AccessControl';
import { UserProfileFragment } from 'app/modules/auth/graphql/fragments/generated/UserProfile';
import { AllowedPermissionActionsEnum, AllowedPermissionsSubjectEnum } from 'app/types/schema';

const action = AllowedPermissionActionsEnum.Switch;
const subject = AllowedPermissionsSubjectEnum.Tenant;

export const canSwitchTenants = (permissions: UserProfileFragment['workspacePermissions']) =>
  isAccessible(permissions, action, subject);
